<div class="container">
  @if (paxConnections$ | async; as paxConnections) {
    @if (
      paxConnections.response &&
      paxConnections.response.connections.length === 0
    ) {
      <div class="text-base p-32 flex-center">None</div>
      <div class="text-xs opacity-6 flex-center">
        Data may not be available until ~24 hours prior.
      </div>
    } @else if (paxConnections.isLoading && !paxConnections.response) {
      <div class="loading-container">
        <mat-spinner color="accent" [diameter]="32"></mat-spinner>
      </div>
    } @else if (
      paxConnections.response && paxConnections.response.connections.length > 0
    ) {
      <app-data-box headerTitle="" class="mt-32 mb-24 width-100">
        <mat-radio-group class="flex-around" [(ngModel)]="filter">
          <mat-radio-button color="accent" value="all" name="filter"
            >All</mat-radio-button
          >
          <mat-radio-button color="accent" value="caution" name="filter">
            <span class="caution-color font-medium">&lt; 45 min</span>
          </mat-radio-button>
          <mat-radio-button color="accent" value="warning" name="filter">
            <span class="warn-color font-medium">&lt; 20 min</span>
          </mat-radio-button>
        </mat-radio-group>
      </app-data-box>
      @for (pax of paxConnections.response.connections; track pax.seat) {
        @if (
          filter() === "all" ||
          (filter() === "caution" &&
            pax.delta &&
            pax.delta.as("minutes") < 45) ||
          (filter() === "warning" && pax.delta && pax.delta.as("minutes") < 20)
        ) {
          <div class="conn-container thin-gray-border">
            <div class="conn-col">
              <div class="text-sm">{{ pax.seat }}</div>
              <div class="label-3">Seat</div>
            </div>
            <div class="airline-col">
              <div class="text-sm flt-with-logo">
                @if (getLogo(pax.airline); as logo) {
                  <img
                    [src]="getLogo(pax.airline)"
                    width="30px"
                    height="30px"
                    (error)="logoError($event)"
                  />
                } @else {
                  <div class="text-sm">{{ pax.airline }}</div>
                }
                {{ pax.airline }}
                {{ pax.flight }}
              </div>
            </div>
            <div class="delta-col text-sm">
              <div>{{ pax.time }}</div>
              <div class="opacity-6">{{ pax.gate }}</div>
            </div>
            <div class="conn-col text-base">
              <div [class]="getDeltaClass(pax)">
                {{ pax.delta | duration }}
              </div>
            </div>
          </div>
        }
      }
    }
    <div class="data-status">
      <app-data-status
        [isLoading]="paxConnections.isLoading"
        [timestamp]="paxConnections.response?.timestamp"
        (refresh)="refresh()"
      ></app-data-status>
    </div>
    @if (paxConnections.isLoading) {
      <mat-progress-bar
        class="progress-bar-bottom"
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    }
  }
</div>
